
import { useCallback, useState } from "react";
import { Card } from "@/components/ui/Card";
import { reseedSettings } from "@/lib/api/endpoints";

export function DangerCard() {
  const [running, setRunning] = useState(false);
  const [result, setResult] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const onReseed = useCallback(async () => {
    if (
      !window.confirm(
        "Reseed default templates?\n\nThis refreshes the setup for the four default product types (Saree, Lehenga, Suit, Kurta). Template names you have customised are kept. Continue?",
      )
    ) {
      return;
    }
    setRunning(true);
    setError(null);
    setResult(null);
    try {
      const body = await reseedSettings();
      const u = body.updated.length;
      const c = body.created.length;
      setResult(`Updated ${u}, created ${c}.`);
      setTimeout(() => setResult(null), 4000);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Reseed failed");
    } finally {
      setRunning(false);
    }
  }, []);

  return (
    <Card
      title="Danger zone"
      subtitle="Operations that touch shared data. Safe to re-run."
      tone="danger"
    >
      <div className="flex items-center justify-between gap-4">
        <div>
          <p className="text-[13px] font-medium text-zinc-900 dark:text-zinc-100">Reseed default templates</p>
          <p className="mt-0.5 text-[11px] text-zinc-500 dark:text-zinc-400">
            Refreshes the setup for Saree, Lehenga, Suit, Kurta. Custom
            template names are preserved.
          </p>
        </div>
        <button
          type="button"
          onClick={onReseed}
          disabled={running}
          className="rounded-lg border border-red-200 dark:border-red-900/60 bg-white dark:bg-surface px-3 py-1.5 text-[12px] font-medium text-red-700 dark:text-red-300 transition hover:bg-red-50 dark:hover:bg-red-950/40 disabled:opacity-50"
        >
          {running ? "Reseeding…" : "Reseed"}
        </button>
      </div>
      {result ? (
        <p className="mt-3 font-mono text-[11px] text-emerald-700 dark:text-emerald-300">{result}</p>
      ) : null}
      {error ? <p className="mt-3 text-[12px] text-red-600 dark:text-red-400">{error}</p> : null}
    </Card>
  );
}
